// ─── AÑO DINÁMICO DEL FOOTER ──────────────────────────────────
(() => {
  "use strict";
  const yearEl = document.getElementById("year");
  if (yearEl) yearEl.textContent = new Date().getFullYear();
})();
